import styled from 'styled-components';

const H1 = styled.h1`
 font-size: 28px;
    font-weight: 400;
    color: black;
`;

export default H1;
